
<template>
  <svg viewBox="0 0 24 24"><path fill="currentColor" d="M18 6.41L16.59 5L12 9.58L7.41 5L6 6.41l6 6z"></path><path fill="currentColor" d="m18 13l-1.41-1.41L12 16.17l-4.59-4.58L6 13l6 6z"></path></svg>
</template>

<script>
export default {
  name: 'ArrowDown'
}
</script>